import * as React from 'react';

function SvgUmbrellaWorkCalendar(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
            <g transform="rotate(-18 12 19)">
                <path d="M12 4C6 4 3 9 3 12h18C21 9 18 4 12 4z" />
                <path d="M12 4c-1.8 2.5 -2.5 5.5 -2.5 8" />
                <path d="M12 4c1.8 2.5 2.5 5.5 2.5 8" />

                <line x1="12" y1="12" x2="12" y2="19" />
            </g>

            <line x1="7" x2="17" y1="19" y2="19" />
        </svg>
    );
}

export default SvgUmbrellaWorkCalendar;
